/**
 * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
 * Original file: /npm/keen-slider@5.5.1/keen-slider.esm.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
function t (t, n, e) {
  return (
    n in t
      ? Object.defineProperty(t, n, {
          value: e,
          enumerable: !0,
          configurable: !0,
          writable: !0
        })
      : (t[n] = e),
    t
  )
}
function n (t, n) {
  var e = Object.keys(t)
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t)
    n &&
      (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(t, n).enumerable
      })),
      e.push.apply(e, r)
  }
  return e
}
function e (e) {
  for (var r = 1; r < arguments.length; r++) {
    var i = null != arguments[r] ? arguments[r] : {}
    r % 2
      ? n(Object(i), !0).forEach(function (n) {
          t(e, n, i[n])
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
      : n(Object(i)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t))
        })
  }
  return e
}
function r (t) {
  return (
    (function (t) {
      if (Array.isArray(t)) return i(t)
    })(t) ||
    (function (t) {
      if ('undefined' != typeof Symbol && Symbol.iterator in Object(t))
        return Array.from(t)
    })(t) ||
    (function (t, n) {
      if (!t) return
      if ('string' == typeof t) return i(t, n)
      var e = Object.prototype.toString.call(t).slice(8, -1)
      'Object' === e && t.constructor && (e = t.constructor.name)
      if ('Map' === e || 'Set' === e) return Array.from(t)
      if (
        'Arguments' === e ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)
      )
        return i(t, n)
    })(t) ||
    (function () {
      throw new TypeError(
        'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
      )
    })()
  )
}
function i (t, n) {
  ;(null == n || n > t.length) && (n = t.length)
  for (var e = 0, r = new Array(n); e < n; e++) r[e] = t[e]
  return r
}
function o (t) {
  var n,
    i,
    o,
    a,
    f,
    s,
    l,
    d,
    h,
    v,
    p,
    m,
    b,
    g,
    w,
    y,
    M,
    O,
    S,
    A,
    j,
    k,
    x,
    P,
    E,
    T,
    D,
    C,
    L,
    V,
    X,
    Y,
    z,
    H,
    I = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    q = 'data-keen-slider-moves',
    F = 'data-keen-slider-v',
    W = [],
    _ = null,
    N = !1,
    R = !1,
    U = 0,
    $ = []
  function B (t, n, e) {
    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}
    t.addEventListener(n, e, r), W.push([t, n, e, r])
  }
  function G (t) {
    if (O && S === Z(t) && ft()) {
      var e = nt(t).x
      if (!rt(t) && P) return K(t)
      P && (Nt(), (A = e), (P = !1)), t.cancelable && t.preventDefault()
      var r = A - e
      ;(E += Math.abs(r)),
        !T && E > 5 && ((T = !0), n.setAttribute(q, !0)),
        Yt(x(r, Jt) * (lt() ? -1 : 1), t.timeStamp),
        (A = e)
    }
  }
  function J (t) {
    O ||
      !ft() ||
      et(t.target) ||
      ((O = !0),
      (P = !0),
      (S = Z(t)),
      (T = !1),
      (E = 0),
      rt(t),
      pt(),
      (M = v),
      (A = nt(t).x),
      Yt(0, t.timeStamp),
      ut('dragStart'))
  }
  function K (t) {
    O &&
      S === Z(t, !0) &&
      ft() &&
      (n.removeAttribute(q), (O = !1), gt(), ut('dragEnd'))
  }
  function Q (t) {
    return t.changedTouches
  }
  function Z (t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      e = n ? Q(t) : tt(t)
    return e ? (e[0] ? e[0].identifier : 'error') : 'default'
  }
  function tt (t) {
    return t.targetTouches
  }
  function nt (t) {
    var n = tt(t)
    return {
      x: ht() ? (n ? n[0].screenY : t.pageY) : n ? n[0].screenX : t.pageX,
      timestamp: t.timeStamp
    }
  }
  function et (t) {
    return t.hasAttribute(y.preventEvent)
  }
  function rt (t) {
    var n = tt(t)
    if (!n) return !0
    var e = n[0],
      r = ht() ? e.clientY : e.clientX,
      i = ht() ? e.clientX : e.clientY,
      o = void 0 !== j && void 0 !== k && Math.abs(k - i) <= Math.abs(j - r)
    return (j = r), (k = i), o
  }
  function it (t) {
    ft() && O && t.preventDefault()
  }
  function ot () {
    B(window, 'orientationchange', Dt),
      B(window, 'resize', function () {
        return Tt()
      }),
      B(n, 'dragstart', function (t) {
        ft() && t.preventDefault()
      }),
      B(n, 'mousedown', J),
      B(y.cancelOnLeave ? n : window, 'mousemove', G),
      y.cancelOnLeave && B(n, 'mouseleave', K),
      B(window, 'mouseup', K),
      B(n, 'touchstart', J, { passive: !0 }),
      B(n, 'touchmove', G, { passive: !1 }),
      B(n, 'touchend', K, { passive: !0 }),
      B(n, 'touchcancel', K, { passive: !0 }),
      B(window, 'wheel', it, { passive: !1 })
  }
  function at () {
    W.forEach(function (t) {
      t[0].removeEventListener(t[1], t[2], t[3])
    }),
      (W = [])
  }
  function ut (t) {
    y[t] && y[t](Jt)
  }
  function ct () {
    return y.centered
  }
  function ft () {
    return void 0 !== i ? i : y.controls
  }
  function st () {
    return y.loop && o > 1
  }
  function lt () {
    return y.rtl
  }
  function dt () {
    return !y.loop && y.rubberband
  }
  function ht () {
    return !!y.vertical
  }
  function vt () {
    D = window.requestAnimationFrame(mt)
  }
  function pt () {
    D && (window.cancelAnimationFrame(D), (D = null)), (C = null)
  }
  function mt (t) {
    C || (C = t)
    var n = t - C,
      e = bt(n)
    if (n >= V) return Yt(L - Y, !1), H ? H() : void ut('afterChange')
    var r = zt(e)
    if (0 === r || st() || dt() || z) {
      if (0 !== r && dt() && !z) return St()
      ;(Y += e), Yt(e, !1), vt()
    } else Yt(e - r, !1)
  }
  function bt (t) {
    return L * X(t / V) - Y
  }
  function gt () {
    switch ((ut('beforeChange'), y.mode)) {
      case 'free':
        Mt()
        break
      case 'free-snap':
        Ot()
        break
      case 'snap':
      default:
        wt()
    }
  }
  function wt () {
    yt((1 === l && 0 !== p ? M : v) + Math.sign(p))
  }
  function yt (t, n) {
    var e =
        arguments.length > 2 && void 0 !== arguments[2]
          ? arguments[2]
          : y.duration,
      r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
      i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
      o = function (t) {
        return 1 + --t * t * t * t * t
      }
    At(Ft((t = qt(t, r, i))), e, o, n)
  }
  function Mt () {
    if (0 === b) return !(!zt(0) || st()) && yt(v)
    var t = y.friction / Math.pow(Math.abs(b), -0.5)
    At((Math.pow(b, 2) / t) * Math.sign(b), 6 * Math.abs(b / t), function (t) {
      return 1 - Math.pow(1 - t, 5)
    })
  }
  function Ot () {
    if (0 === b) return yt(v)
    var t = y.friction / Math.pow(Math.abs(b), -0.5),
      n = (Math.pow(b, 2) / t) * Math.sign(b),
      e = 6 * Math.abs(b / t),
      r = (U + n) / (s / l)
    At((-1 === p ? Math.floor(r) : Math.ceil(r)) * (s / l) - U, e, function (
      t
    ) {
      return 1 - Math.pow(1 - t, 5)
    })
  }
  function St () {
    if ((pt(), 0 === b)) return yt(v, !0)
    var t = 0.04 / Math.pow(Math.abs(b), -0.5),
      n = (Math.pow(b, 2) / t) * Math.sign(b),
      e = function (t) {
        return --t * t * t + 1
      },
      r = b
    At(n, 3 * Math.abs(r / t), e, !0, function () {
      At(Ft(qt(v)), 500, e, !0)
    })
  }
  function At (t, n, e, r, i) {
    pt(), (L = t), (Y = 0), (V = n), (X = e), (z = r), (H = i), (C = null), vt()
  }
  function jt (e) {
    var r = u(t)
    r.length && ((n = r[0]), Tt(e), ot(), ut('mounted'))
  }
  function kt () {
    var t,
      n = I.breakpoints || []
    for (var r in n) window.matchMedia(r).matches && (t = r)
    if (t === _) return !0
    var i = (_ = t) ? n[_] : I
    i.breakpoints && _ && delete i.breakpoints,
      (y = e(e(e({}, Gt), I), i)),
      (N = !0),
      (h = null),
      ut('optionsChanged'),
      Et()
  }
  function xt (t) {
    if ('function' == typeof t) return t()
    var n = y.autoAdjustSlidesPerView
    n || (o = Math.max(t, o))
    var e = st() && n ? o - 1 : o
    return c(t, 1, Math.max(e, 1))
  }
  function Pt () {
    kt(), (R = !0), ut('created')
  }
  function Et (t, n) {
    t && (I = t), n && (_ = null), Ct(), jt(n)
  }
  function Tt (t) {
    var e = window.innerWidth
    if (kt() && (e !== h || t)) {
      h = e
      var r = y.slides
      'number' == typeof r
        ? ((f = null), (o = r))
        : ((f = u(r, n)), (o = f ? f.length : 0))
      var i = y.dragSpeed
      ;(x =
        'function' == typeof i
          ? i
          : function (t) {
              return t * i
            }),
        (s = ht() ? n.offsetHeight : n.offsetWidth),
        (l = xt(y.slidesPerView)),
        (d = c(y.spacing, 0, s / (l - 1) - 1)),
        (s += d),
        (a = ct() ? (s / 2 - s / l / 2) / s : 0),
        Vt()
      var p = !R || (N && y.resetSlide) ? y.initial : v
      Bt(st() ? p : Ht(p)), ht() && n.setAttribute(F, !0), (N = !1)
    }
  }
  function Dt (t) {
    Tt(), setTimeout(Tt, 500), setTimeout(Tt, 2e3)
  }
  function Ct () {
    at(), Xt(), n && n.hasAttribute(F) && n.removeAttribute(F), ut('destroyed')
  }
  function Lt () {
    f &&
      f.forEach(function (t, n) {
        var e = g[n].distance * s - n * (s / l - d / l - (d / l) * (l - 1)),
          r = ht() ? 0 : e,
          i = ht() ? e : 0,
          o = 'translate3d('.concat(r, 'px, ').concat(i, 'px, 0)')
        ;(t.style.transform = o), (t.style['-webkit-transform'] = o)
      })
  }
  function Vt () {
    f &&
      f.forEach(function (t) {
        var n = 'calc('.concat(100 / l, '% - ').concat((d / l) * (l - 1), 'px)')
        ht()
          ? ((t.style['min-height'] = n), (t.style['max-height'] = n))
          : ((t.style['min-width'] = n), (t.style['max-width'] = n))
      })
  }
  function Xt () {
    if (f) {
      var t = ['transform', '-webkit-transform']
      ;(t = [].concat(
        r(t),
        ht ? ['min-height', 'max-height'] : ['min-width', 'max-width']
      )),
        f.forEach(function (n) {
          t.forEach(function (t) {
            n.style.removeProperty(t)
          })
        })
    }
  }
  function Yt (t) {
    var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
      e =
        arguments.length > 2 && void 0 !== arguments[2]
          ? arguments[2]
          : Date.now()
    _t(t, e), n && (t = Ut(t)), (U += t), Rt()
  }
  function zt (t) {
    var n = (s * (o - 1 * (ct() ? 1 : l))) / l,
      e = U + t
    return e > n ? e - n : e < 0 ? e : 0
  }
  function Ht (t) {
    return c(t, 0, o - 1 - (ct() ? 0 : l - 1))
  }
  function It () {
    var t = Math.abs(w),
      n = U < 0 ? 1 - t : t
    return {
      direction: p,
      progressTrack: n,
      progressSlides: (n * o) / (o - 1),
      positions: g,
      position: U,
      speed: b,
      relativeSlide: ((v % o) + o) % o,
      absoluteSlide: v,
      size: o,
      slidesPerView: l,
      widthOrHeight: s
    }
  }
  function qt (t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
    return st() ? (n ? Wt(t, e) : t) : Ht(t)
  }
  function Ft (t) {
    return -((-s / l) * t + U)
  }
  function Wt (t, n) {
    var e = ((v % o) + o) % o,
      r = e < (t = ((t % o) + o) % o) ? -e - o + t : -(e - t),
      i = e > t ? o - e + t : t - e,
      a = n ? (Math.abs(r) <= i ? r : i) : t < e ? r : i
    return v + a
  }
  function _t (t, n) {
    clearTimeout(m)
    var e = Math.sign(t)
    if (
      (e !== p && Nt(),
      (p = e),
      $.push({ distance: t, time: n }),
      (m = setTimeout(function () {
        ;($ = []), (b = 0)
      }, 50)),
      ($ = $.slice(-6)).length <= 1 || 0 === p)
    )
      return (b = 0)
    var r = $.slice(0, -1).reduce(function (t, n) {
        return t + n.distance
      }, 0),
      i = $[$.length - 1].time,
      o = $[0].time
    b = c(r / (i - o), -10, 10)
  }
  function Nt () {
    $ = []
  }
  function Rt () {
    ;(w = st() ? (U % ((s * o) / l)) / ((s * o) / l) : U / ((s * o) / l)), $t()
    for (var t = [], n = 0; n < o; n++) {
      var e = (((1 / o) * n - (w < 0 && st() ? w + 1 : w)) * o) / l + a
      st() && (e += e > (o - 1) / l ? -o / l : e < -o / l + 1 ? o / l : 0)
      var r = 1 / l,
        i = e + r,
        u = i < r ? i / r : i > 1 ? 1 - ((i - 1) * l) / 1 : 1
      t.push({
        portion: u < 0 || u > 1 ? 0 : u,
        distance: lt() ? -1 * e + 1 - r : e
      })
    }
    ;(g = t), Lt(), ut('move')
  }
  function Ut (t) {
    if (st()) return t
    var n = zt(t)
    if (!dt()) return t - n
    if (0 === n) return t
    var e
    return t * ((e = n / s), (1 - Math.abs(e)) * (1 - Math.abs(e)))
  }
  function $t () {
    var t = Math.round(U / (s / l))
    t !== v &&
      ((!st() && (t < 0 || t > o - 1)) || ((v = t), ut('slideChanged')))
  }
  function Bt (t) {
    ut('beforeChange'), Yt(Ft(t), !1), ut('afterChange')
  }
  var Gt = {
      autoAdjustSlidesPerView: !0,
      centered: !1,
      breakpoints: null,
      controls: !0,
      dragSpeed: 1,
      friction: 0.0025,
      loop: !1,
      initial: 0,
      duration: 500,
      preventEvent: 'data-keen-slider-pe',
      slides: '.keen-slider__slide',
      vertical: !1,
      resetSlide: !1,
      slidesPerView: 1,
      spacing: 0,
      mode: 'snap',
      rtl: !1,
      rubberband: !0,
      cancelOnLeave: !0
    },
    Jt = {
      controls: function (t) {
        i = t
      },
      destroy: Ct,
      refresh: function (t) {
        Et(t, !0)
      },
      next: function () {
        yt(v + 1, !0)
      },
      prev: function () {
        yt(v - 1, !0)
      },
      moveToSlide: function (t, n) {
        yt(t, !0, n)
      },
      moveToSlideRelative: function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          e = arguments.length > 2 ? arguments[2] : void 0
        yt(t, !0, e, !0, n)
      },
      resize: function () {
        Tt(!0)
      },
      details: function () {
        return It()
      },
      options: function () {
        var t = e({}, y)
        return delete t.breakpoints, t
      }
    }
  return Pt(), Jt
}
function a (t) {
  return Array.prototype.slice.call(t)
}
function u (t) {
  var n =
    arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document
  return 'function' == typeof t
    ? a(t())
    : 'string' == typeof t
    ? a(n.querySelectorAll(t))
    : t instanceof HTMLElement != !1
    ? [t]
    : t instanceof NodeList != !1
    ? t
    : []
}
function c (t, n, e) {
  return Math.min(Math.max(t, n), e)
}
Math.sign ||
  (Math.sign = function (t) {
    return (t > 0) - (t < 0) || +t
  })
export { o as default }
var s = 'undefined' != typeof globalThis ? globalThis : window
s.KeenSlider551 = o
//# sourceMappingURL=/sm/9f84869b3f114f9db80399b3dd519d56b532f5f7e9255a19004a7e54f0b93c57.map
